import {createElement, Component, PropTypes} from 'rlink-react';
import contentLoader from 'helpers/content-loader';
import {FormattedMessage} from 'react-intl';
import fontAwesome from 'rlink-lesscore/icons/font-awesome.less';
import {NavLink} from 'rlink-router/component';
import css from 'static/style/dow.less';

export default class SidebarNav extends Component {
  componentDidMount () {
    if (!isMobile()) {
      this.updateSidebar();
    }

    window.addEventListener('resize', () => {
      if (!isMobile()) {
        this.updateSidebar();
      }
    });
  }

  updateSidebar () {
    let cookies = this.props.getCookies();
    let navOpen = false;
    if ('sidebarVisible' in cookies ? cookies.sidebarVisible === 'true' : cookies.sidebarVisibleFallback === 'true') {
      navOpen = true;
    }

    this.props.setNavState(navOpen);
  }

  toggleNav (e, preventDefaultEvent = false) {
    if (preventDefaultEvent) {
      e.preventDefault();
    }
    if (this.props.navOpen === true) {
      document.cookie = 'sidebarVisibleFallback=;path=/;expires=Wed, 02 May 2525 01:15:11 GMT';
      document.cookie = 'sidebarVisible=;path=/;domain=dawnofwar.com;expires=Wed, 02 May 2525 01:15:11 GMT';
    } else {
      document.cookie = 'sidebarVisibleFallback=true;path=/;expires=Wed, 02 May 2525 01:15:11 GMT';
      document.cookie = 'sidebarVisible=true;path=/;domain=dawnofwar.com;expires=Wed, 02 May 2525 01:15:11 GMT';
    }

    this.updateSidebar();
    return false;
  }


  render () {
    return (
      <div className={css['navigation-ui']}>
        <a href="" onClick={e => this.toggleNav(e, true)} className={css['navigation-sidebar-open-link']}>
          <img src={contentLoader('burger.png')} />

          <span>
            <FormattedMessage
              id="ui.label.button.OPEN_MAIN_MENU"
              defaultMessage="Menu"
              description="Button appearing on every page of the Dawn of War site which opens the main navigation menu. Try to keep it close to 4 characters." />
          </span>
        </a>

        <nav className={css['navigation-sidebar']}>
          <div className={css.background} />
          <a href="" onClick={e => this.toggleNav(e, true)} className={css['navigation-sidebar-close-link']}>
            <span>&#215;</span>
            <span>
              <FormattedMessage
                id="ui.label.button.CLOSE_MAIN_MENU"
                defaultMessage="Close"
                description="Button appearing on the main navigation menu which closes it. Try to keep it close to 4 characters." />
            </span>
          </a>
          <ul className={css['sidebar-links']}>
            {
              // TODO: REPLACE {...link} with actual link object/types
              this.props.links.main.map(link => <SidebarLink key={link.href} toggleNav={ev => this.toggleNav(ev)} currentPage={(link.view === this.props.view)} {... link} />)
            }
          </ul>
          <ul className={css['sidebar-social-links']}>
            {
              // TODO: REPLACE {...link} with actual link object/types
              this.props.links.social.map(link => <SidebarLink key={link.href} {... link} />)
            }
          </ul>
        </nav>
      </div>);
  }
}

SidebarNav.propTypes = {
  links: PropTypes.object,
  view: PropTypes.string,
  navOpen: PropTypes.bool,
  getCookies: PropTypes.func,
  setNavState: PropTypes.func,
};

SidebarNav.defaultProps = {
  className: '',
  view: '',
  links: {
    main: [
      {
        title: <FormattedMessage
          id="ui.label.menu.HOME"
          defaultMessage="Game"
          description="Menu item in the main navigation menu pointing to the main game info page." />,
        href: '/',
        view: 'home',
        children: [
          {
            view: 'faction',
            params: {faction: 'spacemarines'},
            key: '/spacemarines',
            title: <FormattedMessage
              id="ui.label.menu.SPACE_MARINES"
              defaultMessage="Space Marines"
              description="Menu item in the main navigation menu. Space Marines is the name of a faction in the game." />,
          }, {
            view: 'faction',
            params: {faction: 'eldar'},
            key: '/eldar',
            title: <FormattedMessage
              id="ui.label.menu.ELDAR"
              defaultMessage="Eldar"
              description="Menu item in the main navigation menu. Eldar is the name of a faction in the game." />,
          }, {

            view: 'faction',
            params: {faction: 'orks'},
            key: '/orks',
            title: <FormattedMessage
              id="ui.label.menu.ORKS"
              defaultMessage="Orks"
              description="Menu item in the main navigation menu. Orks is the name of a faction in the game." />,
          },
        ],
      }, {
        title: <FormattedMessage
          id="ui.label.menu.COMMUNITY"
          defaultMessage="Community"
          description="Menu item in the main navigation menu pointing to the news page." />,
        href: '/community',
        params: {"filter": "all"},
        view: 'news',
      }, {
        title: <FormattedMessage
          id="ui.label.menu.MEDIA"
          defaultMessage="Media"
          description="Menu item in the main navigation menu pointing to the media download page." />,
        href: '/media',
        view: 'media',
        params: { },
      }, {
        title: <FormattedMessage
          id="ui.label.menu.BUY"
          defaultMessage="Buy"
          description="Menu item in the main navigation menu pointing to the store page." />,
        href: '/buy',
        view: 'buy',
        params: { },
        emphasize: true,
      },
    ],
    social: [
      {
        href: 'https://www.facebook.com/DawnOfWar',
        target: '_blank',
        isExternal: true,
        className: `${fontAwesome.fa} ${fontAwesome['fa-facebook']} ${fontAwesome['fa-lg']}`,
      }, {
        href: 'https://twitter.com/dawnofwar',
        target: '_blank',
        isExternal: true,
        className: `${fontAwesome.fa} ${fontAwesome['fa-twitter']} ${fontAwesome['fa-lg']}`,
      }, {
        href: 'https://www.youtube.com/channel/UCWxzyJYKnfcLRel2Io5NP9g',
        target: '_blank',
        isExternal: true,
        className: `${fontAwesome.fa} ${fontAwesome['fa-youtube']} ${fontAwesome['fa-lg']}`,
      }, {
        href: 'https://www.twitch.tv/relicentertainment/profile',
        target: '_blank',
        isExternal: true,
        className: `${fontAwesome.fa} ${fontAwesome['fa-twitch']} ${fontAwesome['fa-lg']}`,
      },
    ],
  },
};


class SidebarLink extends Component {
  render () {
    if (this.props.isExternal) {
      return (
        <li key={`${this.props.href}-${this.props.view}`}>

          <a target={this.props.target}
            href={this.props.href}
            className={`${(this.props.className in css) ? css[this.props.className] : this.props.className}`}>
            {this.props.title}
          </a>
        </li>);
    } else {
      return (
        <li className={(this.props.emphasize) ? css.emphasize : ''} key={`${this.props.href}-${this.props.view}`}>
          <NavLink href={{
            view: this.props.view,
            params: this.props.params,
            returnTransition: 'fade',
            transition: 'fade',
          }}
            onClick={ev => (isMobile() ? this.props.toggleNav(ev) : [])}
            className={`
              ${(this.props.currentPage) ? css.active : ''}
              ${(this.props.className in css) ? css[this.props.className] : this.props.className}`}>
            {this.props.title}
          </NavLink>

          {(typeof this.props.children !== 'undefined') ? this.renderLinkChildren(this.props.children) : []}
        </li>);
    }
  }

  renderLinkChildren (children) {
    return (
      <ul className={css['sidebar-link-children']}>
        {children.map(child =>
          <li key={`${child.key}`}>
            {!('isDisabled' in child)
             ? <NavLink href={{
               view: child.view,
               params: child.params,
               transition: 'fade',
             }}
               onClick={ev => (isMobile() ? this.props.toggleNav(ev) : (window.scrollTo(0, 0)))}
               className={`${css[child.className]} ${(child.view === this.props.view) ? css.active : ''}`}>
               {child.title}
             </NavLink>
             : <a href="#"
               className={css.disabled}
               onClick={e => false}>
               {child.title}
             </a>
            }

            {(child.isDisabled) ? (<span className={css['teaser-text']}>
              <FormattedMessage
                id="ui.label.button.DISABLED_CHILD"
                defaultMessage="Coming Soon"
                description="Label for buttons that are disabled within the navigation menu." />
            </span>) : []}
          </li>)
        }
      </ul>
    );
  }
}

function isMobile () {
  return (window.innerWidth <= 767);
}



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/components/sidebar-nav.jsx